import { ref, computed } from 'vue';


/**
 * In props must be required, but undefined:
 * usePagination: {
		type: Boolean,
		default: undefined,
	},
 */

const useOptionalVModel = (props, field, emit, defaultValue) => {
	const internalRef = ref(defaultValue);
	const modelRef = computed({
		get: () => props[field] !== undefined ? props[field] : internalRef.value,
		set: value => {
			if (props[field] !== undefined) {
				emit(`update:${field}`, value);
			} else {
				internalRef.value = value;
				emit(`update:${field}`, value);
			}
		},
	});
	return modelRef;
};

export { useOptionalVModel };
